import React, { useState, useEffect, useMemo } from 'react'
import Modal from 'react-bootstrap/Modal'
import { Button, Form, Spinner } from 'react-bootstrap'
import ErrorAlert from '../Alerts/ErrorAlert';
import LoadingAlert from '../Alerts/LoadingAlert';
import { UsersFetchAPI } from '../../api/Users';
import Swal from 'sweetalert2';

import './WaitersSelect.css';
// Modal component to select the waiter of the order, this modal is used in the payment post when the user wants to assign a waiter to the order
function ModalWaiters({ showWaiters, setShowWaiters, onConfirmWaiter, defaultWaiterId = null }) {
    const [loading, setLoading] = useState(false);
    const [waiters, setWaiters] = useState([]);
    const [selectedWaiterId, setSelectedWaiterId] = useState(defaultWaiterId ?? "");

    const token = useMemo(() => localStorage.getItem("x-access-machine-token") || localStorage.getItem("x-access-token"), []);

    const branchoffice = useMemo(() => {
        try { return JSON.parse(localStorage.getItem('branchoffice')) } catch { return null }
    }, [])

    const business = useMemo(() => {
        try { return JSON.parse(localStorage.getItem('business')) } catch { return null }
    }, [])

    const close = () => setShowWaiters(false)

    // Function to get the waiters of the branch office
    const getWaiters = async () => {
        try {
            setLoading(true);
            let response = await UsersFetchAPI.getUsersByRoleAndBranchoffice(branchoffice.id, 15);
            setWaiters(response.data.users);
        } catch (err) {
            console.log(err)
            setWaiters([]);
        } finally {
            setLoading(false);
        }
    }

    //Hook to get the waiters when the modal is opened and set the default selection if exists
    useEffect(() => {
        if (showWaiters) {
            getWaiters();
            if (defaultWaiterId !== null && defaultWaiterId !== undefined && String(defaultWaiterId) !== '') {
                setSelectedWaiterId(String(defaultWaiterId))
            } else {
                // Keep last selection as default (nice for cashier flow)
                const last = localStorage.getItem('pos_selected_waiter_id')
                if (last !== null && last !== undefined && last !== '') {
                    setSelectedWaiterId(last)
                }
            }

        }
    }, [showWaiters, defaultWaiterId])


    const selectedWaiter = useMemo(() => {
        return waiters.find(w => String(w.user_id) === String(selectedWaiterId)) ?? null
    }, [waiters, selectedWaiterId])

    // Function to confirm the selection of the waiter and pass the data to the parent component
    const confirm = () => {
        if (!selectedWaiterId) {
            onConfirmWaiter(selectedWaiter)
            //If the user dont want to select a waiter we continue with the flow without assigning a waiter to the order
            close()
            return
        }

        // Persist last selection
        localStorage.setItem('pos_selected_waiter_id', String(selectedWaiterId))
        localStorage.setItem('pos_selected_waiter', JSON.stringify(selectedWaiter ?? {}))
        if (typeof onConfirmWaiter === 'function') {
            onConfirmWaiter(selectedWaiter)
        }

        close()
    }

    return (
        <>
            {loading ? (
                <div className="sp-wt__loading">
                    <span className="sp-wt__spinner" aria-hidden="true"></span>
                    <span className="sp-wt__loadingtxt">Cargando meseros...</span>
                </div>
            ) : (
                <>
                    <p className="sp-wt__intro">Selecciona el mesero de la orden.</p>

                    <div className="sp-wt__field">
                        <label className="sp-wt__label"><i className="uil uil-user"></i> Mesero</label>
                        <div className="sp-wt__selectwrap">
                            <select
                                className="sp-wt__select"
                                value={selectedWaiterId}
                                onChange={(e) => setSelectedWaiterId(e.target.value)}
                            >
                                <option value="">-- Seleccionar / Sin mesero --</option>
                                {waiters.map((w) => (
                                    <option key={w.user_id} value={w.user_id}>
                                        {w.user_name ?? ""}
                                    </option>
                                ))}
                            </select>
                            <i className="uil uil-angle-down sp-wt__selectchev"></i>
                        </div>
                    </div>
                </>
            )}

            <div className="sp-wt__foot">
                <button className="sp-wt__btn sp-wt__btn--primary" onClick={confirm} disabled={loading}>
                    <i className="uil uil-check"></i> Guardar
                </button>
            </div>
        </>
    )
}

export default ModalWaiters